import Axios from 'axios';

export class CallCenterService {
  /** @type {Axios} */
  #commonServicesAxiosInstance;

  constructor(axiosInstance) {
    if (!axiosInstance) {
      throw new Error('\'axiosInstance\' is required.');
    }
    this.#commonServicesAxiosInstance = axiosInstance;
  }

  /**
   * @param {object} [user]
   * @returns {Promise<AxiosResponse>}
   */
  async getCallCenters(user) {
    const { callCenter } = user ?? {};
    if (callCenter?.isAdmin || !callCenter) {
      return await this.#commonServicesAxiosInstance.get('/callCenters');
    }

    const userId = user?.assetManagementRecordId;
    return await this.#commonServicesAxiosInstance.get(`users/${userId}/callCenter`);
  }
}

const axiosInstance = Axios.create({
  baseURL: process.env.REACT_APP_COMMON_SERVICES_API,
  headers: {
    'Ocp-Apim-Subscription-Key': process.env.REACT_APP_NSD_API_KEY
  },
  withCredentials: true
});
export default new CallCenterService(axiosInstance);
